var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            "close-on-click-modal": _vm.showClose,
            "show-close": _vm.showClose,
            title: _vm.titleContent,
            top: _vm.topContent,
            visible: _vm.isShowHint,
            width: _vm.widthContent,
            center: "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.isShowHint = $event
            },
          },
        },
        [
          _c("div", [_vm._t("content")], 2),
          _c(
            "template",
            { slot: "footer" },
            [
              _vm.leftBtnContent !== ""
                ? _c(
                    "el-button",
                    {
                      staticStyle: { margin: "0 10px" },
                      attrs: { plain: "", type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.onNoOrYes(0)
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n\t\t\t\t" + _vm._s(_vm.leftBtnContent) + "\n\t\t\t"
                      ),
                    ]
                  )
                : _vm._e(),
              _vm.rightBtnContent !== ""
                ? _c(
                    "el-button",
                    {
                      staticStyle: { margin: "0 10px" },
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.onNoOrYes(1)
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n\t\t\t\t" + _vm._s(_vm.rightBtnContent) + "\n\t\t\t"
                      ),
                    ]
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }